import React from 'react';

export const patternRotate = 30;
export const canvasSize = 16;

export const strokeWidth = canvasSize / 8;

export const PatternBase = ({
	id,
	backgroundColor,
	children,
	patternTransform = '',
	...restProps
}) => {
	return (
		<pattern
			id={id}
			width={canvasSize}
			height={canvasSize}
			patternTransform={`translate(${canvasSize / 2}, ${
				canvasSize / 2
			}) ${patternTransform}`}
			patternUnits="userSpaceOnUse"
			x="50%"
			y="50%"
			{...restProps}
		>
			<rect width={canvasSize} height={canvasSize} fill={backgroundColor} />
			{children}
		</pattern>
	);
};
